import NavAndSearch from '../NavAndSearch'

import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

export default function FormView({ fields }) {

  function fieldLookup(lookup) {
    return fields.find((i) => i.id === lookup)
  }

  function searchField(lookup) {
    let found = fieldLookup(lookup)
    // console.log(found)
    // to prevent undefined error during first render, this function will only return a value (object) when it is not undefined
    return found !== undefined ? found : {sf_application_name: 'SFPULL_Application__c.loading...__c', field_name: 'loading...'}
  }

  function searchFieldOptions(lookup) {
    let found = fieldLookup(lookup)
    // to prevent undefined error during first render, this function will only return a value (object) when it is not undefined
    if (found !== undefined) {
      const options = [found.option1, found.option2, found.option3, found.option4, found.option5, found.option6, found.option7, found.option8, found.option9, found.option10]
      const validOptions = options.filter((option) => option !== null)
      return validOptions.map((option) => (
        <Button
          className='m-1'
          variant="outline-warning"
          key={option}
          onClick={() => navigator.clipboard.writeText(option)
        }>
          {option}
        </Button>
      ))
    }
  }

  return (
    <>
      <NavAndSearch />
      <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded' style={{ marginTop: '4.5rem' }}>
        <Row>
          <Col>
            <h5>🏢 Entity / DBA</h5>
            <hr style={{margin: '0 0 1rem 0'}}/>
          </Col>
        </Row>
        <Row>
          <Col>
              <p>{searchField(141).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(141).sf_application_name)}>
              {searchField(141).sf_application_name.slice(22, -3)}
              </Button>
          </Col>
          <Col>
              <p>{searchField(129).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(129).sf_application_name)}>
              {searchField(129).sf_application_name.slice(22, -3)}
              </Button>
          </Col>
          <Col>
              <p>{searchField(156).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(156).sf_application_name)}>
              {searchField(156).sf_application_name.slice(22, -3)}
              </Button>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Contact Person</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(122).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(122).sf_application_name)}>
            {searchField(122).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(123).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(123).sf_application_name)}>
            {searchField(123).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(124).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(124).sf_application_name)}>
            {searchField(124).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(121).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(121).sf_application_name)}>
            {searchField(121).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Legal Address</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(143).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(143).sf_application_name)}>
            {searchField(143).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(139).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(139).sf_application_name)}>
            {searchField(139).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(142).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(142).sf_application_name)}>
            {searchField(142).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(144).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(144).sf_application_name)}>
            {searchField(144).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(140).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(140).sf_application_name)}>
            {searchField(140).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>DBA Address</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(131).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(131).sf_application_name)}>
            {searchField(131).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(127).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(127).sf_application_name)}>
            {searchField(127).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(130).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(130).sf_application_name)}>
            {searchField(130).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(132).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(132).sf_application_name)}>
            {searchField(132).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(128).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(128).sf_application_name)}>
            {searchField(128).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Customer Service</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(125).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(125).sf_application_name)}>
            {searchField(125).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(126).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(126).sf_application_name)}>
            {searchField(126).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(135).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(135).sf_application_name)}>
            {searchField(135).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Incorporation</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>
            
            <p>{searchField(120).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(120).sf_application_name)}>
            {searchField(120).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(120)}</p>

            <p>{searchField(133).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(133).sf_application_name)}>
            {searchField(133).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(137).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(137).sf_application_name)}>
            {searchField(137).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(134).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(134).sf_application_name)}>
            {searchField(134).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Business Model</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(138).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(138).sf_application_name)}>
            {searchField(138).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(152).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(152).sf_application_name)}>
            {searchField(152).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(155).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(155).sf_application_name)}>
            {searchField(155).sf_application_name.slice(22, -3)}
            </Button>

          </Col>
        </Row>
        <Row>
          <Col>
            <p>{searchField(153).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(153).sf_application_name)}>
            {searchField(153).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
            <p>{searchField(136).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(136).sf_application_name)}>
            {searchField(136).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
            <p>{searchField(151).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(151).sf_application_name)}>
            {searchField(151).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>{searchField(145).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(145).sf_application_name)}>
            {searchField(145).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
            <p>{searchField(148).field_name}</p>
            <Button variant="outline-success" onClick={() =>  navigator.clipboard.writeText(searchField(148).sf_application_name)}>
            {searchField(148).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
          </Col>
        </Row>
      </Container>
      <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded'>
        <Row>
          <Col>
            <h5>🧑‍🚀 Ownership</h5>
            <hr style={{margin: '0 0 1rem 0'}}/>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Owner 1 Personal</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(224).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(224).sf_application_name)}>
            {searchField(224).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(225).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(225).sf_application_name)}>
            {searchField(225).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(226).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(226).sf_application_name)}>
            {searchField(226).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(216).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(216).sf_application_name)}>
            {searchField(216).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(317).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(317).sf_application_name)}>
            {searchField(317).sf_application_name}
            </Button>

            <p>{searchField(316).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(316).sf_application_name)}>
            {searchField(316).sf_application_name}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Owner 1 Contact & Address</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(212).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(212).sf_application_name)}>
            {searchField(212).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(214).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(214).sf_application_name)}>
            {searchField(214).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(213).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(213).sf_application_name)}>
            {searchField(213).sf_application_name.slice(22, -3)}
            </Button>

            

            <p>{searchField(219).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(219).sf_application_name)}>
            {searchField(219).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(217).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(217).sf_application_name)}>
            {searchField(217).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(218).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(218).sf_application_name)}>
            {searchField(218).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(220).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(220).sf_application_name)}>
            {searchField(220).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Owner 1 IDs</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(209).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(209).sf_application_name)}>
            {searchField(209).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(215).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(215).sf_application_name)}>
            {searchField(215).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(211).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(211).sf_application_name)}>
            {searchField(211).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(221).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(221).sf_application_name)}>
            {searchField(221).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>{searchField(210).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(210).sf_application_name)}>
            {searchField(210).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
            <p>{searchField(222).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(222).sf_application_name)}>
            {searchField(222).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchField(223).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(223).sf_application_name)}>
            {searchField(223).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
            <p>{searchField(208).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(208).sf_application_name)}>
            {searchField(208).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Owner 2 Personal</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(244).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(244).sf_application_name)}>
            {searchField(244).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(233).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(233).sf_application_name)}>
            {searchField(233).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(245).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(245).sf_application_name)}>
            {searchField(245).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(236).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(236).sf_application_name)}>
            {searchField(236).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(318).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(318).sf_application_name)}>
            {searchField(318).sf_application_name}
            </Button>

            <p>{searchField(316).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(316).sf_application_name)}>
            {searchField(316).sf_application_name}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Owner 2 Contact & Address</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(231).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(231).sf_application_name)}>
            {searchField(231).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(234).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(234).sf_application_name)}>
            {searchField(234).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(232).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(232).sf_application_name)}>
            {searchField(232).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(239).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(239).sf_application_name)}>
            {searchField(239).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(237).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(237).sf_application_name)}>
            {searchField(237).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(238).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(238).sf_application_name)}>
            {searchField(238).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(240).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(240).sf_application_name)}>
            {searchField(240).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Owner 2 IDs</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(228).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(228).sf_application_name)}>
            {searchField(228).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(235).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(235).sf_application_name)}>
            {searchField(235).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(230).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(230).sf_application_name)}>
            {searchField(230).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(241).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(241).sf_application_name)}>
            {searchField(241).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>{searchField(229).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(229).sf_application_name)}>
            {searchField(229).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
            <p>{searchField(242).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(242).sf_application_name)}>
            {searchField(242).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchField(243).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(243).sf_application_name)}>
            {searchField(243).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col>
            <p>{searchField(227).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(227).sf_application_name)}>
            {searchField(227).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
      </Container>
      <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded'>
        <Row>
          <Col>
            <h5>💰 Sales and 🛠️ Processing</h5>
            <hr style={{margin: '0 0 1rem 0'}}/>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Sales %</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(246).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(246).sf_application_name)}>
            {searchField(246).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(247).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(247).sf_application_name)}>
            {searchField(247).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(283).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(283).sf_application_name)}>
            {searchField(283).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(284).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(284).sf_application_name)}>
            {searchField(284).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(285).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(285).sf_application_name)}>
            {searchField(285).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(288).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(288).sf_application_name)}>
            {searchField(288).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(286).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(286).sf_application_name)}>
            {searchField(286).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(287).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(287).sf_application_name)}>
            {searchField(287).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(158).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(158).sf_application_name)}>
            {searchField(158).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(159).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(159).sf_application_name)}>
            {searchField(159).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Sales Volume</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(157).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(157).sf_application_name)}>
            {searchField(157).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(162).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(162).sf_application_name)}>
            {searchField(162).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(170).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(170).sf_application_name)}>
            {searchField(170).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(160).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(160).sf_application_name)}>
            {searchField(160).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(161).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(161).sf_application_name)}>
            {searchField(161).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(169).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(169).sf_application_name)}>
            {searchField(169).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(163).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(163).sf_application_name)}>
            {searchField(163).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(164).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(164).sf_application_name)}>
            {searchField(164).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(171).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(171).sf_application_name)}>
            {searchField(171).sf_application_name.slice(22, -3)}
            </Button>

          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Billing Model</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(272).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(272).sf_application_name)}>
            {searchField(272).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(272)}</p>

            <p>{searchField(255).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(255).sf_application_name)}>
            {searchField(255).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(255)}</p>

            <p>{searchField(254).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(254).sf_application_name)}>
            {searchField(254).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(254)}</p>

            <p>{searchField(259).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(259).sf_application_name)}>
            {searchField(259).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(261).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(261).sf_application_name)}>
            {searchField(261).sf_application_name.slice(22, -3)}
            </Button>


          </Col>
          </Row>
          <Row>
            <Col className='colGroup p-3 m-2 rounded'>
              <h4>Processing History</h4>
              <hr style={{margin: '0 0 1rem 0'}}/>

              <p>{searchField(250).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(250).sf_application_name)}>
              {searchField(250).sf_application_name.slice(22, -3)}
              </Button>
              <p>{searchFieldOptions(250)}</p>

              <p>{searchField(253).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(253).sf_application_name)}>
              {searchField(253).sf_application_name.slice(22, -3)}
              </Button>
              <p>{searchFieldOptions(253)}</p>

              <p>{searchField(249).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(249).sf_application_name)}>
              {searchField(249).sf_application_name.slice(22, -3)}
              </Button>
              
              <p>{searchField(267).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(267).sf_application_name)}>
              {searchField(267).sf_application_name.slice(22, -3)}
              </Button>

              <p>{searchField(266).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(266).sf_application_name)}>
              {searchField(266).sf_application_name.slice(22, -3)}
              </Button>
            </Col>
            <Col className='colGroup p-3 m-2 rounded'>
              <h4>Website</h4>
              <hr style={{margin: '0 0 1rem 0'}}/>

              <p>{searchField(156).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(156).sf_application_name)}>
              {searchField(156).sf_application_name.slice(22, -3)}
              </Button>

              <p>{searchField(273).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(273).sf_application_name)}>
              {searchField(273).sf_application_name.slice(22, -3)}
              </Button>

              <p>{searchField(269).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(269).sf_application_name)}>
              {searchField(269).sf_application_name.slice(22, -3)}
              </Button>

              <p>{searchField(263).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(263).sf_application_name)}>
              {searchField(263).sf_application_name.slice(22, -3)}
              </Button>
              <p>{searchFieldOptions(263)}</p>

              <p>{searchField(257).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(257).sf_application_name)}>
              {searchField(257).sf_application_name.slice(22, -3)}
              </Button>
              <p>{searchFieldOptions(257)}</p>

              <p>{searchField(258).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(258).sf_application_name)}>
              {searchField(258).sf_application_name.slice(22, -3)}
              </Button>
              <p>{searchFieldOptions(258)}</p>

              <p>{searchField(268).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(268).sf_application_name)}>
              {searchField(268).sf_application_name.slice(22, -3)}
              </Button>

            </Col>
            <Col className='colGroup p-3 m-2 rounded'>
              <h4>Delivery / Fulfillment</h4>
              <hr style={{margin: '0 0 1rem 0'}}/>

              <p>{searchField(172).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(172).sf_application_name)}>
              {searchField(172).sf_application_name.slice(22, -3)}
              </Button>

              <p>{searchField(166).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(166).sf_application_name)}>
              {searchField(166).sf_application_name.slice(22, -3)}
              </Button>
              <p>{searchFieldOptions(166)}</p>

              <p>{searchField(250).field_name}</p>
              <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(250).sf_application_name)}>
              {searchField(250).sf_application_name.slice(22, -3)}
              </Button>
              <p>{searchFieldOptions(250)}</p>
            </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Payment</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(167).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(167).sf_application_name)}>
            {searchField(167).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(167)}</p>

            <p>{searchField(174).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(174).sf_application_name)}>
            {searchField(174).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(251).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(251).sf_application_name)}>
            {searchField(251).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(168).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(168).sf_application_name)}>
            {searchField(168).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(168)}</p>

            <p>{searchField(270).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(270).sf_application_name)}>
            {searchField(270).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(175).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(175).sf_application_name)}>
            {searchField(175).sf_application_name.slice(22, -3)}
            </Button>

          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Security</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(262).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(262).sf_application_name)}>
            {searchField(262).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(262)}</p>

            <p>{searchField(256).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(256).sf_application_name)}>
            {searchField(256).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(256)}</p>

            <p>{searchField(248).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(248).sf_application_name)}>
            {searchField(248).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(248)}</p>

            <p>{searchField(274).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(274).sf_application_name)}>
            {searchField(274).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(252).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(252).sf_application_name)}>
            {searchField(252).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Others</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(165).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(165).sf_application_name)}>
            {searchField(165).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(173).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(173).sf_application_name)}>
            {searchField(173).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(264).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(264).sf_application_name)}>
            {searchField(264).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(275).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(275).sf_application_name)}>
            {searchField(275).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(265).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(265).sf_application_name)}>
            {searchField(265).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(265)}</p>
          </Col>
        </Row>
      </Container>
      <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded'>
        <Row>
          <Col>
            <h5>🏦 Bank Details</h5>
            <hr style={{margin: '0 0 1rem 0'}}/>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Account</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(181).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(181).sf_application_name)}>
            {searchField(181).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(176).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(176).sf_application_name)}>
            {searchField(176).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(182).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(182).sf_application_name)}>
            {searchField(182).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(183).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(183).sf_application_name)}>
            {searchField(183).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(177).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(177).sf_application_name)}>
            {searchField(177).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(177)}</p>

          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Bank Contact</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(179).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(179).sf_application_name)}>
            {searchField(179).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(178).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(178).sf_application_name)}>
            {searchField(178).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(180).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(180).sf_application_name)}>
            {searchField(180).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col></Col>
        </Row>
      </Container>
      <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded'>
        <Row>
          <Col>
            <h5>🚛 Fullfillment and  💁‍♂️ Customer Service</h5>
            <hr style={{margin: '0 0 1rem 0'}}/>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Fulfillment</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(202).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(202).sf_application_name)}>
            {searchField(202).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(202)}</p>

            <p>{searchField(192).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(192).sf_application_name)}>
            {searchField(192).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(192)}</p>

            <p>{searchField(201).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(201).sf_application_name)}>
            {searchField(201).sf_application_name.slice(22, -3)}
            </Button>

          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Fulfillment Vendor</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(197).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(197).sf_application_name)}>
            {searchField(197).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(198).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(198).sf_application_name)}>
            {searchField(198).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(199).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(199).sf_application_name)}>
            {searchField(199).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(196).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(196).sf_application_name)}>
            {searchField(196).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(193).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(193).sf_application_name)}>
            {searchField(193).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(195).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(195).sf_application_name)}>
            {searchField(195).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(200).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(200).sf_application_name)}>
            {searchField(200).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(194).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(194).sf_application_name)}>
            {searchField(194).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Customer Service</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(207).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(207).sf_application_name)}>
            {searchField(207).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(207)}</p>

            <p>{searchField(204).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(204).sf_application_name)}>
            {searchField(204).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(203).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(203).sf_application_name)}>
            {searchField(203).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(205).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(205).sf_application_name)}>
            {searchField(205).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(206).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(206).sf_application_name)}>
            {searchField(206).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(289).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(289).sf_application_name)}>
            {searchField(289).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(290).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(290).sf_application_name)}>
            {searchField(290).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(291).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(291).sf_application_name)}>
            {searchField(291).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
      </Container>
      <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded'>
        <Row>
          <Col>
            <h5>🏪 Site Survey and 🤝 References</h5>
            <hr style={{margin: '0 0 1rem 0'}}/>
          </Col>
        </Row>
        <Row>
        <Col className='colGroup p-3 m-2 rounded'>
            <h4>Site Survey</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(280).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(280).sf_application_name)}>
            {searchField(280).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(280)}</p>

            <p>{searchField(281).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(281).sf_application_name)}>
            {searchField(281).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(281)}</p>

            <p>{searchField(282).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(282).sf_application_name)}>
            {searchField(282).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(282)}</p>

            <p>{searchField(276).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(276).sf_application_name)}>
            {searchField(276).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(276)}</p>

            <p>{searchField(277).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(277).sf_application_name)}>
            {searchField(277).sf_application_name.slice(22, -3)}
            </Button>
            <p>{searchFieldOptions(277)}</p>

            <p>{searchField(278).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(278).sf_application_name)}>
            {searchField(278).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(279).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(279).sf_application_name)}>
            {searchField(279).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Trade</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(185).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(185).sf_application_name)}>
            {searchField(185).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(186).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(186).sf_application_name)}>
            {searchField(186).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(187).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(187).sf_application_name)}>
            {searchField(187).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(184).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(184).sf_application_name)}>
            {searchField(184).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Manufacturer / Supplier</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(189).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(189).sf_application_name)}>
            {searchField(189).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(190).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(190).sf_application_name)}>
            {searchField(190).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(191).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(191).sf_application_name)}>
            {searchField(191).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(188).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(188).sf_application_name)}>
            {searchField(188).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
      </Container>
      <Container fluid='xxl' className='boostrapContainer mb-3 pb-3 rounded'>
        <Row>
          <Col>
            <h5>💲Pricing</h5>
            <hr style={{margin: '0 0 1rem 0'}}/>
          </Col>
        </Row>
        <Row>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Rates</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(299).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(299).sf_application_name)}>
            {searchField(299).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(297).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(297).sf_application_name)}>
            {searchField(297).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(308).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(308).sf_application_name)}>
            {searchField(308).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(300).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(300).sf_application_name)}>
            {searchField(300).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(303).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(303).sf_application_name)}>
            {searchField(303).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>per Transaction / Item</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(313).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(313).sf_application_name)}>
            {searchField(313).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(294).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(294).sf_application_name)}>
            {searchField(294).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(295).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(295).sf_application_name)}>
            {searchField(295).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(314).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(314).sf_application_name)}>
            {searchField(314).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(296).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(296).sf_application_name)}>
            {searchField(296).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(293).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(293).sf_application_name)}>
            {searchField(293).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(315).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(315).sf_application_name)}>
            {searchField(315).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(298).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(298).sf_application_name)}>
            {searchField(298).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(309).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(309).sf_application_name)}>
            {searchField(309).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(310).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(310).sf_application_name)}>
            {searchField(310).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(305).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(305).sf_application_name)}>
            {searchField(305).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
          <Col className='colGroup p-3 m-2 rounded'>
            <h4>Periodical</h4>
            <hr style={{margin: '0 0 1rem 0'}}/>

            <p>{searchField(292).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(292).sf_application_name)}>
            {searchField(292).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(301).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(301).sf_application_name)}>
            {searchField(301).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(302).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(302).sf_application_name)}>
            {searchField(302).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(304).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(304).sf_application_name)}>
            {searchField(304).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(306).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(306).sf_application_name)}>
            {searchField(306).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(307).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(307).sf_application_name)}>
            {searchField(307).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(311).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(311).sf_application_name)}>
            {searchField(311).sf_application_name.slice(22, -3)}
            </Button>

            <p>{searchField(312).field_name}</p>
            <Button variant="outline-success" onClick={() => navigator.clipboard.writeText(searchField(312).sf_application_name)}>
            {searchField(312).sf_application_name.slice(22, -3)}
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  )
}
